/**
 * Theme accessibility enhancements for scanner findings that are hard to
 * fix purely in Liquid (third-party widgets, CMS HTML, many target=_blank).
 * Klaviyo Option 3 dialog behavior on popup open/close.
 *
 * No document-wide MutationObserver — that fought GPO/app DOM updates and
 * kept product pages loading / unresponsive.
 */
(function () {
  'use strict';

  var NEW_WINDOW_ID = 'a11y-new-window-message';

  function warnNewWindow(anchor) {
    if (!anchor || anchor.getAttribute('aria-describedby')) return;
    var existing = anchor.getAttribute('aria-label') || '';
    if (/opens in a new (tab|window)/i.test(existing)) return;
    if (document.getElementById(NEW_WINDOW_ID)) {
      anchor.setAttribute('aria-describedby', NEW_WINDOW_ID);
    }
    if (existing) {
      if (!/opens in a new (tab|window)/i.test(existing)) {
        anchor.setAttribute('aria-label', existing.replace(/\s+$/, '') + ' (opens in a new tab)');
      }
    }
  }

  function enhanceTargetBlank(root) {
    (root || document)
      .querySelectorAll('a[target="_blank"]')
      .forEach(warnNewWindow);
  }

  function replacePresentationalB(root) {
    (root || document)
      .querySelectorAll(
        '.product__description b:not([data-a11y-b-upgraded]), .rte b:not([data-a11y-b-upgraded]), .product-single__description b:not([data-a11y-b-upgraded]), [itemprop="description"] b:not([data-a11y-b-upgraded]), .product__info-container b:not([data-a11y-b-upgraded])'
      )
      .forEach(function (b) {
        if (b.closest('svg')) return;
        var strong = document.createElement('strong');
        strong.setAttribute('data-a11y-b-upgraded', '1');
        for (var i = 0; i < b.attributes.length; i++) {
          var attr = b.attributes[i];
          strong.setAttribute(attr.name, attr.value);
        }
        while (b.firstChild) strong.appendChild(b.firstChild);
        if (b.parentNode) b.parentNode.replaceChild(strong, b);
      });
  }

  function fixReputonNestedInteractive(root) {
    (root || document)
      .querySelectorAll('a.reputon-link button, button.reputon-link a, a button.reputon-bt, a.reputon-link .reputon-bt')
      .forEach(function (inner) {
        var outer = inner.closest('a, button');
        if (!outer || outer === inner) return;
        if (outer.tagName === 'A' && inner.tagName === 'BUTTON') {
          var label =
            inner.getAttribute('aria-label') ||
            inner.getAttribute('data-content') ||
            outer.getAttribute('aria-label') ||
            'Leave a Review';
          outer.setAttribute('aria-label', label);
          if (inner.parentNode) inner.parentNode.removeChild(inner);
        }
      });
  }

  /* accessibility utility don't remove — Monster Upsells #mu-empty-cart img alt */
  function fixMuEmptyCartAlt() {
    var container = document.getElementById('mu-empty-cart');
    if (!container) return false;
    var imgs = container.getElementsByTagName('img');
    var fixed = false;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.hasAttribute('alt') || img.getAttribute('alt') === '') {
        img.setAttribute('alt', 'Empty cart');
        fixed = true;
      }
    }
    return fixed;
  }

  /* accessibility utility don't remove — MU cart is not theme cart-drawer; watch body */
  function watchMuEmptyCartAlt() {
    fixMuEmptyCartAlt();

    var pending = false;
    function scheduleFix() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        fixMuEmptyCartAlt();
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.id === 'mu-empty-cart' ||
            (node.tagName === 'IMG' && node.closest && node.closest('#mu-empty-cart')) ||
            (typeof node.className === 'string' && node.className.indexOf('mu-') !== -1) ||
            (node.querySelector && node.querySelector('#mu-empty-cart'))
          ) {
            scheduleFix();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (fixMuEmptyCartAlt() || tries >= 60) clearInterval(timer);
    }, 500);
  }

  function run(root) {
    enhanceTargetBlank(root);
    replacePresentationalB(root);
    fixReputonNestedInteractive(root);
    /* accessibility utility don't remove */
    fixMuEmptyCartAlt();
  }

  /* ------------------------------------------------------------------ */
  /* Klaviyo popup Option 3 — wait for form via short-lived observer     */
  /* ------------------------------------------------------------------ */
  var klaviyoA11y = {
    lastFocus: null,
    dialog: null,
    onKeyDown: null,
    waitObserver: null
  };

  function focusableIn(root) {
    if (!root) return [];
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
  }

  function findKlaviyoForm(formId) {
    if (formId) {
      var byTestId = document.querySelector('[data-testid="klaviyo-form-' + formId + '"]');
      if (byTestId) return byTestId;
    }
    return document.querySelector('form.klaviyo-form');
  }

  function findDialogRoot(form) {
    if (!form) return null;
    var node = form;
    for (var i = 0; i < 8 && node; i++) {
      var role = node.getAttribute && node.getAttribute('role');
      if (role === 'dialog' || role === 'alertdialog') return node;
      if (node.getAttribute && node.getAttribute('aria-modal') === 'true') return node;
      node = node.parentElement;
    }
    node = form.parentElement;
    for (var j = 0; j < 6 && node && node !== document.body; j++) {
      var style = window.getComputedStyle(node);
      if (
        (style.position === 'fixed' || style.position === 'absolute') &&
        node.querySelector &&
        node.querySelector('form.klaviyo-form')
      ) {
        return node;
      }
      node = node.parentElement;
    }
    return form;
  }

  function labelCloseButtons(root) {
    if (!root) return;
    root.querySelectorAll('button, [role="button"]').forEach(function (btn) {
      var text = (btn.textContent || '').replace(/\s+/g, '');
      var aria = btn.getAttribute('aria-label') || '';
      if (aria) return;
      if (text === '×' || text === '✕' || text === 'x' || text === 'X') {
        btn.setAttribute('aria-label', 'Close');
      }
    });
  }

  function stopWaitingForForm() {
    if (klaviyoA11y.waitObserver) {
      klaviyoA11y.waitObserver.disconnect();
      klaviyoA11y.waitObserver = null;
    }
  }

  function enhanceKlaviyoDialog(formId) {
    var form = findKlaviyoForm(formId);
    if (!form) return false;

    stopWaitingForForm();

    var dialog = findDialogRoot(form);
    if (!dialog) return false;

    klaviyoA11y.lastFocus = document.activeElement;
    klaviyoA11y.dialog = dialog;

    if (!dialog.getAttribute('role')) dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      dialog.setAttribute('aria-label', 'Email signup offer');
    }

    labelCloseButtons(dialog);

    var focusables = focusableIn(dialog);
    var start =
      dialog.querySelector('[aria-label="Close"], [aria-label="close"]') ||
      form.querySelector('input:not([type="hidden"])') ||
      focusables[0];

    if (start && typeof start.focus === 'function') {
      requestAnimationFrame(function () {
        try {
          start.focus();
        } catch (err) {}
      });
    }

    if (klaviyoA11y.onKeyDown) {
      document.removeEventListener('keydown', klaviyoA11y.onKeyDown, true);
    }

    klaviyoA11y.onKeyDown = function (e) {
      if (!klaviyoA11y.dialog) return;

      if (e.key === 'Escape' || e.keyCode === 27) {
        var closeBtn =
          klaviyoA11y.dialog.querySelector('[aria-label="Close"], [aria-label="close"]');
        if (!closeBtn) {
          var buttons = klaviyoA11y.dialog.querySelectorAll('button');
          for (var i = 0; i < buttons.length; i++) {
            var t = (buttons[i].textContent || '').replace(/\s+/g, '');
            if (t === '×' || t === '✕' || t === 'x' || t === 'X') {
              closeBtn = buttons[i];
              break;
            }
          }
        }
        if (closeBtn) closeBtn.click();
        return;
      }

      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var list = focusableIn(klaviyoA11y.dialog);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', klaviyoA11y.onKeyDown, true);
    return true;
  }

  function waitForKlaviyoForm(formId) {
    stopWaitingForForm();
    if (enhanceKlaviyoDialog(formId)) return;

    var tries = 0;
    var maxTries = 40; /* ~2s if mutations are sparse; also hard-timeout below */

    klaviyoA11y.waitObserver = new MutationObserver(function () {
      tries += 1;
      if (enhanceKlaviyoDialog(formId) || tries >= maxTries) {
        stopWaitingForForm();
      }
    });
    klaviyoA11y.waitObserver.observe(document.body, { childList: true, subtree: true });

    /* Hard stop so we never leave an observer running */
    setTimeout(stopWaitingForForm, 3000);
  }

  function teardownKlaviyoDialog() {
    stopWaitingForForm();
    if (klaviyoA11y.onKeyDown) {
      document.removeEventListener('keydown', klaviyoA11y.onKeyDown, true);
      klaviyoA11y.onKeyDown = null;
    }
    var prev = klaviyoA11y.lastFocus;
    klaviyoA11y.dialog = null;
    klaviyoA11y.lastFocus = null;
    if (prev && typeof prev.focus === 'function') {
      requestAnimationFrame(function () {
        try {
          prev.focus();
        } catch (err) {}
      });
    }
  }

  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    if (e.detail.type === 'open') {
      waitForKlaviyoForm(e.detail.formId);
    }
    if (e.detail.type === 'close') {
      teardownKlaviyoDialog();
    }
  });

  function initPageEnhancements() {
    run(document);
    /* Late-injected review widgets — one delayed pass, then stop */
    setTimeout(function () {
      run(document);
    }, 2000);

    /* accessibility utility don't remove */
    watchMuEmptyCartAlt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageEnhancements);
  } else {
    initPageEnhancements();
  }
})();
